import { Action, createReducer, on } from '@ngrx/store';
import { ProgressActivityModel, Session, SessionEvaluationInstrument } from '@tekman/onmat/models';
import * as stepsActions from './steps.actions';

export const SESSIONS_FEATURE_KEY = 'steps';

export interface State {
  sessions: Array<Session[]>;
  evaluationInstruments: Array<SessionEvaluationInstrument[]>;
  otherActivities: Array<SessionEvaluationInstrument[]>;
  exercisesProgress: ProgressActivityModel[];
  loaded: { [key: string]: boolean };
  updated?: Session[];
}

export interface StepsPartialState {
  readonly [SESSIONS_FEATURE_KEY]: State;
}

export const initialState: State = {
  sessions: [],
  evaluationInstruments: [],
  otherActivities: [],
  loaded: {},
  exercisesProgress: [],
  updated: undefined,
};

const stepsReducer = createReducer(
  initialState,
  on(stepsActions.loadSessionsSuccess, (state, { stepId, sessions }) => ({
    ...state,
    sessions: { ...state.sessions, [stepId]: sessions },
    exercisesProgress: [],
    loaded: { ...state.loaded },
  })),
  on(stepsActions.resetSessionsLoaded, state => ({
    ...state,
    loaded: { ...state.loaded, sessions: false },
  })),
  on(stepsActions.orderedSessionsSuccess, state => ({
    ...state,
    loaded: { ...state.loaded, sessions: true },
  })),
  on(stepsActions.loadEvaluationInstrumentsSuccess, (state, { stepId, evaluationInstruments }) => ({
    ...state,
    evaluationInstruments: { ...state.evaluationInstruments, [stepId]: evaluationInstruments },
    loaded: { ...state.loaded, instruments: true },
  })),
  on(stepsActions.loadOtherActivitiesSuccess, (state, { stepId, otherActivities }) => ({
    ...state,
    otherActivities: { ...state.otherActivities, [stepId]: otherActivities },
    loaded: { ...state.loaded, other: true },
  })),
  on(stepsActions.loadStudentExerciseProgressSuccess, (state, { exercisesProgress }) => ({
    ...state,
    exercisesProgress: [...state.exercisesProgress, exercisesProgress],
  })),
  on(
    stepsActions.loadStudentExerciseProgressFailure,
    stepsActions.loadSessionsFailure,
    stepsActions.loadEvaluationInstrumentsFailure,
    stepsActions.loadOtherActivitiesFailure,
    (state, { error }) => ({
      ...state,
      message: error?.message,
      loaded: { ...state.loaded, [error?.type]: false },
    })
  ),
  on(stepsActions.updateStepsSuccess, (state, { sessions }) => ({
    ...state,
    updated: sessions,
  })),
  on(stepsActions.updateStepsFailure, state => ({
    ...state,
    updated: [],
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return stepsReducer(state, action);
}
